import script from "./ClientCabinetDocumentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetDocumentTab.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetDocumentTab.vue?vue&type=style&index=0&id=0b5e5a58&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5e5a58"]])

export default __exports__